import * as React from 'react';

class List extends React.Component {
  render() {
    return (
      <ul>
        <li>大哥你就说牛不牛逼吧</li>
      </ul>
    )
  }
}

export default List;
